import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Permission, RolePermissions } from 'app/models/user.model';
import { AdministracionService } from 'app/services/administracion.service';
import { take, switchMap, of, catchError } from 'rxjs';
import { FuseAlertType } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';

@Component({
    selector: 'roles',
    templateUrl: './roles.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./roles.component.scss'],
    animations: fuseAnimations,
})
export class RolesComponent implements OnInit {
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: '',
    };
    showAlertCrear: boolean = false;
    showAlertEditar: boolean = false;

    arrPermissions: Permission[] = [];
    dataSource: MatTableDataSource<RolePermissions>;
    modalModel: RolePermissions;
    modalCrear: boolean = false;
    modalEditar: boolean = false;

    cargandoDatos: boolean = false;
    guardandoRol: boolean = false;
    displayedColumns: string[] = ['NOMBRE', 'admin', 'judicial', 'consultas', 'pagares', 'auditoria', 'sistema', 'reportes', 'editar'];

    constructor(private route: Router, private _administracion: AdministracionService) //private _fuseAlertService: FuseAlertService,
    {}

    goback(): void {
        this.route.navigateByUrl('home/admin');
    }

    ngOnInit() {
        /* Configuracion basica */
        this._administracion
            .listarPermisos()
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.arrPermissions = data;
                },
                error: (err: any) => {
                    //console.log(err);
                },
                complete: () => {},
            });
        this.listarRolesPermisos();
    }

    listarRolesPermisos() {
        this.cargandoDatos = true;
        this._administracion
            .listarRolesPermisos()
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    this.dataSource = new MatTableDataSource<RolePermissions>(data);
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                    this.cargandoDatos = false;
                },
                error: (err: any) => {
                    //console.log(err);
                    this.cargandoDatos = false;
                },
                complete: () => {},
            });
    }

    handleClick(element: any) {}

    hasItem(facture: any) {
        // return this.factureSelected.some(({ id }) => {
        //     return id === facture.id
        // })
    }

    showModalCrear() {
        this.modalModel = {
            ID: null,
            NOMBRE: null,
            permissions: this.arrPermissions.map((m) => ({ ...m, ACTIVO: false })),
        };
        this.modalCrear = true;
    }
    closeModalCrear() {
        this.modalCrear = false;
        this.modalModel = null;
    }

    showModalEditar(row: RolePermissions) {
        this.modalModel = row;
        this.modalEditar = true;
    }

    closeModalEditar() {
        this.modalEditar = false;
        this.modalModel = null;
        this.showAlertEditar = false
        this.showAlertCrear = false;
    }

    guardarRol() {
        if (this.modalModel) {
            this.guardandoRol = true;
            if (!this.modalModel.permissions.some((s) => s.ACTIVO == true)) {
                //console.log("No guardar si no tiene al menos 1 permiso activo");
                this.alert = {
                    type: 'error',
                    message: 'Se requiere al menos asignar 1 permiso al rol.',
                };

                this.showAlertCrear = true;
                // setTimeout(() => {
                //     this.showAlertCrear = false;
                // }, 3000);

                this.guardandoRol = false;
                return;
            }
            // console.log(this.modalModel);
            // this.guardandoRol = true;
            this._administracion
                .creaActualizaRol(this.modalModel.ID, this.modalModel.NOMBRE, this.modalModel.permissions)
                .pipe(take(1))
                .subscribe({
                    next: (data) => {
                        this.listarRolesPermisos();
                        this.guardandoRol = false;
                        this.closeModalCrear();
                        this.closeModalEditar();
                        this.alert = {
                            type: 'success',
                            message: 'Operación realizada exitosamente',
                        };
        
                        this.showAlertCrear = true;
                    },
                    error: (err: any) => {
                        //console.log(err);

                        switch (err.status) {
                            default:
                                this.alert = {
                                    type: 'error',
                                    message: 'No se pudo completar la operación',
                                };
                                break;
                        }
                        this.showAlertCrear = true;
                        this.showAlertEditar = true;

                        // setTimeout(() => {
                        //     this.showAlertCrear = false;
                        //     this.showAlertEditar = false;
                        // }, 3000);

                        this.guardandoRol = false;
                    },
                    complete: () => {},
                });
        }
    }
}
